Postlogin.AssessmentProgress = (function () {
    const $assessmentProgressTable = $('#assessment-progress-table');
    const progressBars = [];

    const setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const userId = $(this).attr('data-user-id');
                const barProgress = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, bar) {
                        bar.path.setAttribute('stroke', state.color);
                        bar.setText(`${Math.round(bar.value() * 100)} %`);
                    },
                });
                barProgress.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = barProgress;
            });
        }
    };

    const initBootstrapTable = function () {
        const userId = $assessmentProgressTable.data('user-id');
        const currentUserId = $assessmentProgressTable.data('current-user-id');

        $assessmentProgressTable.bootstrapTable({
            formatNoMatches() {
                return 'No activity to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: +userId === +currentUserId ? '/my-profile/assessment-progress/json/' : `/users/${userId}/assessment-progress/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: '',
                    field: 'completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assessment',
                    field: 'assessment_type',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned By',
                    field: 'teacher_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Started',
                    field: 'date_started',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                    field: 'date_last_access',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Completed',
                    field: 'date_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Progress',
                    field: 'progress',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'llll', ['date_last_access']);

                    row.teacher_id = `${row.first_name} ${row.last_name}`;

                    if (row.subtitle) {
                        row.assessment_type += `<br><em>${row.subtitle}</em>`;
                    }

                    if (
                        +row.teacher_id === userId
                        || Jr.getCurrentUserRoleId() === 4
                        || Jr.getCurrentUserRoleId() === 5
                        || Jr.getCurrentUserRoleId() === 6
                    ) {
                        const assignmentViewUrl = $assessmentProgressTable
                            .attr('data-assignment-view-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        row.assessment_type = `<a href="${assignmentViewUrl}">${row.assessment_type}</a>`;
                    } else if (+userId === +currentUserId) {
                        const assessmentStartUrl = $assessmentProgressTable
                            .attr('data-assessment-start-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':user_assessment_id', row.user_assessment_id);
                        row.assessment_type = `<a href="${assessmentStartUrl}">${row.assessment_type}</a>`;
                    }

                    row.percentage_complete = row.progress;
                    if (+row.percentage_complete === 100) {
                        row.completed = ' <i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.progress = ''
                        + '<div'
                        + '    class="progress-indicator hidden-print"'
                        + `    id="student-progress-${row.assignment_id}"`
                        + `    data-progress="${row.percentage_complete}"`
                        + `    data-user-id="${userId}"`
                        + '    ></div>'
                        + `<span class="visible-print">${row.percentage_complete}%</span>`;

                    row.actions = '';
                    if (row.percentage_complete > 0) {
                        let assessmentViewUrl;
                        if (userId === currentUserId) {
                            assessmentViewUrl = $assessmentProgressTable
                                .attr('data-my-ccis-assessment-view-url')
                                .replace(':user_assessment_id', row.user_assessment_id);
                        } else {
                            assessmentViewUrl = $assessmentProgressTable
                                .attr('data-ccis-assessment-view-url')
                                .replace(':user_id', row.user_id)
                                .replace(':user_assessment_id', row.user_assessment_id);
                        }

                        row.actions += `<a href="${assessmentViewUrl}" class="btn btn-hollow-pink">See ${
                            +row.percentage_complete === 100 ? '' : 'Partial '
                        }Results</a>`;
                    }
                });

                return formattedResult;
            },
            onLoadSuccess() {
                setupProgressBars();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_complete < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_complete < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_complete < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    const init = function () {
        initBootstrapTable();
    };

    return {
        init,
    };
}());
